<div mat-dialog-title>
  <span>{{ 'USE_EXISTING.TITLE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<q9-info-message *ngIf="error" type="error">{{ error | translate }}</q9-info-message>

<mat-dialog-content>
  <q9-text-field
    [formControl]="searchControl"
    [label]="'USE_EXISTING.SEARCH_PLACEHOLDER' | translate"></q9-text-field>
  <div class="selection-list">
    <q9-content-loader [isLoading]="isLoading()"></q9-content-loader>
    <ng-container *ngIf="!isLoading()">
      <ng-container *ngIf="diagrams$ | async as diagrams">
        <mat-selection-list
          *ngIf="diagrams.length"
          #selectionList
          [multiple]="false"
          (selectionChange)="changeSelected($event)">
          <mat-list-option
            *ngFor="let diagram of diagrams"
            [value]="diagram"
            [disabled]="diagram._id === diagramVersionId"
            role="option"
            color="primary">
            {{ diagram.name | htmlEncoder: true }}
          </mat-list-option>
        </mat-selection-list>
        <q9-tab-placeholder *ngIf="!diagrams.length && !firstStart" class="empty-state">
          <mat-icon icon svgIcon="empty-filter"></mat-icon>
          <span text>{{ 'USE_EXISTING.NO_RESULTS' | translate }}</span>
        </q9-tab-placeholder>
      </ng-container>
      <q9-tab-placeholder *ngIf="firstStart" class="empty-state">
        <mat-icon icon svgIcon="placeholders:general-placeholder"></mat-icon>
        <span text>{{ 'USE_EXISTING.FIRST_START' | translate }}</span>
      </q9-tab-placeholder>
    </ng-container>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button (click)="useExistingDiagram()">
    {{ 'USE_EXISTING.SUBMIT' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
